import { DummySetListener } from './DummySetListener';

export class SequentialDummySetListener extends DummySetListener{
    public addRecords( records:Array<number> ):void {
        for ( let recordId of records ){
            this.addRecord(recordId);
        }
    }
}